<template>
  <div id="HomePage">
    <!-- <div class="zhanwei"></div> -->
    <!-- 轮播图-PC-->
    <div class="container-fuild hidden-xs bgColor" style="height: 410px">
      <el-carousel
        height="410px"
        trigger="click"
        :autoplay="autoplay"
        @change="changeCarIndex"
      >
        <el-carousel-item v-for="(item, index) in swiperList" :key="index">
          <video
            v-if="item.indexOf('?mp4') > -1"
            style="width: 100%; height: 100%; object-fit: fill"
            controls
            :id="'videoPaush' + index"
            :poster="bgImg"
            x5-video-player-type="h5-page"
            playsinline="true"
          >
            <source :src="item" type="video/mp4" />
          </video>
          <img
            v-else
            :src="item"
            width="100%"
            height="100%"
            alt="成都英华科技有限公司"
          />
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 轮播图-yd -->
    <div class="container-fuild visible-xs bgColor" style="height: 200px">
      <van-swipe class="my-swipe" indicator-color="white" @change="onChange">
        <van-swipe-item v-for="(item, index) in swiperList" :key="index">
          <video
            :poster="bgImg"
            ref="myVideo"
            v-if="item.indexOf('?mp4') > -1"
            style="width: 100%; height: 200px; object-fit: fill"
            controls
            :id="'videoPaushPhone' + index"
            x5-video-player-type="h5-page"
            playsinline="true"
          >
            <source :src="item" type="video/mp4" />
          </video>
          <img
            v-else
            :src="item"
            alt="成都英华科技有限公司"
            width="100%"
            height="200px"
          />
        </van-swipe-item>
      </van-swipe>
    </div>
    <!-- 新闻咨询PC -->
    <div id="bigData" class="container-fuild hidden-xs">
      <div class="container">
        <div class="row bigData-container">
          <div class="col-xs-6 col-sm-6 col-md-6 newPad">
            <div class="new-tab dashed">
              <span class="">最新动态</span>
              <div class="new-clear"></div>
            </div>
            <div class="news-left" id="reasons1">
              <div class="bgColor" style="height: 167px; overflow: hidden">
                <img
                  v-show="listOne.mobileImage"
                  class="img-responsive"
                  :src="listOne.mobileImage"
                  :alt="listOne.description"
                />
              </div>
              <div class="news">
                <time>{{ listOne.issueTime }}</time>
                <h2 class="dot1" @click="goNewsFristDetail(listOne.id)">
                  {{ listOne.title }}
                </h2>
                <p class="dot2">{{ listOne.description }}</p>
              </div>
            </div>
          </div>
          <div style="display: none">
            成都英华科技有限公司坐落于中国（四川）自由贸易试验区成都市高新区金融城，注册资本5000万元人民币，是高新区政府重点扶持的高新技术企业。
            英华科技是国内“数字孪生”先行者，充分利用信息模型、传感、通信、大数据、人工智能等技术为工程设计、建设、运行维护提供全生命周期的科学管控与智慧交互。
            英华科技的研发和技术团队均是从事物联网技术及IT技术开发与应用10年以上的技术精英和资深项目管理人员，以创新的科技与高水平的施工管理经验凝结为企业核心，形成了以信息系统集成、三维数字化应用、软件平台开发、物联网设备集成为主营业务的数字科技承包商，服务于新时代智慧城市、智慧电网、智慧工程的建设和运维。为提高政务管理效率，降低施工运维风险，增强城市综合竞争力，促进人民美好生活品质贡献英华力量。
            英华科技秉承“精英华彩，共创共享”的经营理念，全体员工同心同德，以科技创新为核心竞争力。诚邀德才兼备的各界人士，为早日实现中华民族伟大复兴的“中国梦”增砖添瓦。
          </div>
          <div class="col-xs-6 col-sm-6 col-md-6 ydPad">
            <div class="new-tab">
              <span :class="isActive ? 'yellow-line' : ''" @click="tabBtns(0)"
                >企业新闻</span
              >
              <span style="color: #bec0c1">|</span>
              <span :class="isActive ? '' : 'yellow-line'" @click="tabBtns(2)"
                >党建动态</span
              >
              <span
                class="new-more"
                style="font-size: 14px; font-weight: 200"
                @click="goMore"
                >READ MORE></span
              >
            </div>
            <div class="news-right">
              <div class="news-list" v-for="(item, index) in list" :key="index">
                <div>
                  <div class="title">
                    <time>{{ item.issueTime }}</time
                    >&nbsp;&nbsp;|&nbsp;&nbsp;
                    <h2 class="dot1" @click="goNewsDetail(item.id)">
                      {{ item.title }}
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- YD手机端列表 -->
    <div id="newPhone" class="container-fuild visible-xs">
      <div class="whyChooseUs-title text-center wow bounceInDown visible-xs">
        <p style="font-weight: 600; margin: 10px 0 10px; font-size: 10px">
          新闻咨询
        </p>
        <p style="font-size: 10px; margin: 10px 0 10px">NEWS CONSULTATION</p>
      </div>
      <div class="new-tab">
        <div>
          <span
            style="padding: 4px 0px"
            :class="isActive ? 'yellow-line' : ''"
            @click="tabBtns(0)"
            >企业新闻</span
          >
          <span style="color: #1989fa">|</span>
          <span
            style="padding: 4px 0px"
            :class="isActive ? '' : 'yellow-line'"
            @click="tabBtns(2)"
            >党建动态</span
          >
        </div>
        <p class="more-yd" @click="goMore">MORE></p>
      </div>
      <!-- 最新消息滚动 -->
      <van-notice-bar
        left-icon="volume-o"
        @click="goNewsDetail(listOne.id)"
        scrollable
        :speed="35"
        :text="listOne.title ? '最新动态：' + listOne.title : '最新动态：-'"
      />
      <!-- 新闻列表 -->
      <div
        class="item-news"
        v-for="(item, index) in phoneList"
        :key="index"
        @click="goNewsDetail(item.id)"
      >
        <p>{{ item.title }}</p>
        <time>发布时间：{{ item.issueTime }}</time>
        <div class="news-detail">
          <div v-if="item.mobileImage">
            <img :src="item.mobileImage" :alt="item.description" />
          </div>
          <div class="detail">
            {{ item.description }}
          </div>
        </div>
      </div>
      <!-- <div><a class="about-more" @click="goMore">查看更多</a></div> -->
    </div>
  </div>
</template>
<script>
import { WOW } from "wowjs";
import { fileRecord, PageNews } from "@/api/apiAll";
export default {
  name: "HomePage",
  data() {
    return {
      swiperList: [],
      bgImg: "",
      list: [],
      listOne: {},
      phoneList: [],
      showFlag: false,
      btnType: [
        { btn: "btn btn-primary btn1", name: "企业新闻" },
        { btn: "btn btn-default btn2", name: "行业动态" },
      ],
      isActive: true,
      isActive1: false,
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      autoplay: false,
    };
  },
  activated() {
    // 使用缓存之后只调用最新新闻和列表新闻
    this.getList(0);
    this.newList(0);
    this.isActive = true;
  },
  mounted() {
    this.fileRecord("index-lunbo");
    this.fileRecord("bg-img-pic");
    this.getList(0);
    this.newList(0);
    /* wowjs动画 */
    var wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true,
      live: true,
    });
    wow.init();
  },
  methods: {
    /**
     * 轮播
     */
    fileRecord(code) {
      fileRecord({ code: code }).then((res) => {
        if (res.data.code === 0) {
          if (code === "index-lunbo") {
            for (let i in res.data.data.fileList) {
              this.swiperList[i] = this.$imgURL + res.data.data.fileList[i];
            }
          } else if (code === "bg-img-pic") {
            this.bgImg = this.$imgURL + res.data.data.fileList.toString();
          }
        }
      });
    },
    /**
     * pc 切换轮播时暂停
     */
    changeCarIndex() {
      let arrIndex = [];
      this.swiperList.forEach((item, index) => {
        if (item.indexOf("?mp4") > -1) {
          arrIndex.push(index);
        }
      });
      arrIndex.forEach((item) => {
        let videoPaush = document.getElementById("videoPaush" + item);
        videoPaush.pause();
      });
    },
    /**
     * phone 切换轮播时暂停
     * @param {index} 轮播图的下标
     */
    onChange(index) {
      let arrIndex = [];
      this.swiperList.forEach((item, index) => {
        if (item.indexOf("?mp4") > -1) {
          arrIndex.push(index);
        }
      });
      arrIndex.forEach((item) => {
        let videoPaush = document.getElementById("videoPaushPhone" + item);
        videoPaush.pause();
      });
    },
    newList(newsType) {
      const page = {
        pageNum: 1,
        pageSize: 1,
        newsType: newsType,
      };
      PageNews(page).then((res) => {
        if (res.data.code === 0) {
          res.data.data.records[0].mobileImage = this.$imgURL + res.data.data.records[0].mobileImage;
          this.listOne = res.data.data.records[0];
        }
      });
    },
    getList(newsType) {
      const page = {
        pageNum: 1,
        pageSize: 11,
        newsType: newsType,
      };
      PageNews(page).then((res) => {
        if (res.data.code === 0) {
          this.phoneList = res.data.data.records.filter((item, index) => {
            return index < 5;
          }); //手机端显示数据
          //pc端显示数据
          if (newsType) {
            //行业新闻
            this.list = res.data.data.records;
          } else {
            res.data.data.records.splice(0, 1); //删除第一位
            this.list = res.data.data.records;
          }
        }
      });
    },
    // 点击切换新闻
    tabBtns(e) {
      sessionStorage.setItem("dropIndex", e);
      switch (e) {
        case 0:
          this.isActive = true;
          break;
        case 2:
          this.isActive = false;
          break;
        default:
          break;
      }
      this.getList(e);
    },
    // 点击查看更多
    goMore() {
      sessionStorage.setItem("navIndex", 4);
      this.$store.commit("SET_NUM_INDEX", 4);
      if (this.isActive) {
        this.$store.commit("SET_DORPINDEX", "0");
        this.$router.push({
          path: "/news/newsCompany",
        });
      } else {
        this.$store.commit("SET_DORPINDEX", "1");
        this.$router.push({
          path: "/news/newsIndustry",
        });
      }
    },
    /**
     * 点击进入详情页面
     */
    goNewsDetail(id) {
      sessionStorage.setItem("navIndex", 4);
      this.$store.commit("SET_NUM_INDEX", 4);
      if (this.isActive) {
        this.$store.commit("SET_DORPINDEX", "0");
        sessionStorage.setItem("dropIndex", 0);
        this.$router.push({
          path: "/news/newsCompanyDetail",
          query: {
            code: id,
          },
        });
      } else {
        this.$store.commit("SET_DORPINDEX", "1");
        sessionStorage.setItem("dropIndex", 1);
        this.$router.push({
          path: "/news/newsDetail",
          query: {
            code: id,
          },
        });
      }
    },
    /**
     * 点击进最新详情
     */
    goNewsFristDetail(id) {
      sessionStorage.setItem("navIndex", 4);
      this.$store.commit("SET_NUM_INDEX", 4);
      this.$store.commit("SET_DORPINDEX", "0");
      sessionStorage.setItem("dropIndex", 0);
      this.$router.push({
        path: "/news/newsCompanyDetail",
        query: {
          code: id,
        },
      });
    },
    mouseenterBtn() {
      this.showFlag = true;
    },
    mouseleaveBtn() {
      this.showFlag = false;
    },
  },
};
</script>
<style scoped>
/* 整体盒子 */
#HomePage {
  width: 100%;
}
#HomePage .bgColor {
  background: #eee;
}
#HomePage /deep/ .el-carousel__button {
  display: block;
  opacity: 0.48;
  width: 30px;
  height: 5px;
  background-color: #fff;
  border: none;
  outline: 0;
  padding: 0;
  margin: 0;
  cursor: pointer;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  border-radius: 10px;
}
#HomePage /deep/ .el-carousel__indicator.is-active button {
  opacity: 1;
}
#HomePage /deep/ .el-carousel__arrow {
  height: 60px;
  width: 60px;
}
#HomePage /deep/ .el-carousel__arrow i {
  font-size: 30px;
}
/* 轮播图 */
#swiper {
  height: 400px;
}
#swiper /deep/ .swiper-pagination-bullet {
  width: 32px;
  height: 6px;
  border-radius: 3px;
  background-color: #fff;
  /* opacity: 0.5; */
}
#swiper /deep/ .swiper-banner .swiper-pagination-bullet {
  width: 32px;
  height: 6px;
  border-radius: 3px;
  background-color: #fff;
  opacity: 0.5;
}
#swiper /deep/ .swiper-banner .swiper-pagination-bullet-active {
  opacity: 1;
}
#swiper .banner-swiper {
  width: 100%;
  height: 100%;
}
#swiper .banner-swiper .swiper-slide img {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50%;
}
#swiper .banner-swiper .swiper-slide {
  position: relative;
}
#swiper .banner-swiper .swiper-slide-title {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999999999;
  width: 100%;
  height: 100%;
  color: #fff;
  background: rgba(51, 51, 51, 0.534);
  text-align: center;
  line-height: 80px;
}
#swiper .banner-swiper .swiper-slide-title > h1 {
  font-size: 50px;
  margin-top: 5%;
}
#swiper .banner-swiper .swiper-slide-title > p {
  font-size: 20px;
  margin-top: 1%;
  font-weight: 700;
}
/* 新闻中心*/
#bigData {
  padding: 50px 0px;
  transition: all ease 0.6s;
  box-sizing: border-box;
  overflow: hidden;
  min-height: 405px;
}
#bigData .whyChooseUs-title {
  margin-bottom: 50px;
}
#bigData .new-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  /* padding: 0px 0px 20px; */
}
#bigData .new-btn .btn1,
.btn2 {
  outline: none;
  margin: 0 15px;
}
.news-right {
  /* margin: 15px;s */
}
#bigData .new-btn .btn1,
.btn2:focus {
  outline: 0;
}
#bigData .whyChooseUs-title p:nth-of-type(1) {
  font-size: 14px;
  font-weight: 500;
  margin: 0 0 5px;
}
#bigData .whyChooseUs-title p:nth-of-type(2) {
  font-size: 12px;
}
#bigData .bigData-container .news {
  position: relative;
}
#bigData .bigData-container .news-left {
  padding-right: 27%;
}
#bigData .bigData-container img {
  height: 167px;
  width: 100%;
  object-fit: cover
  /* height: auto; */
}
#bigData .bigData-container .news time {
  font-size: 12px;
  color: #666;
}
#bigData .bigData-container .news h2 {
  margin: 0;
  font-size: 12px;
  line-height: 25px;
  /* color: #333; */
  cursor: pointer;
  font-weight: 600;
}
#bigData .bigData-container .dot1 {
  display: -webkit-box;
  display: box;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
#bigData .bigData-container .dot2 {
  display: -webkit-box;
  display: box;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
#bigData .bigData-container .news-right .news-list {
  display: flex;
  align-items: center;
  /* padding: 17px 0px; */
}
#bigData .bigData-container .news-right .news-list h2 {
  margin: 0;
  font-size: 12px;
  color: #404040;
  line-height: 25px;
  /* color: #333; */
  cursor: pointer;
  /* font-weight: 600; */
  /* padding-right: 30px; */
}
#bigData .bigData-container .news-right .news-list .nums {
  margin-right: 20px;
}
#bigData .bigData-container .news-right .news-list .sort-nums {
  width: 100px;
  height: 100px;
  line-height: 100px;
  display: block;
  background: #eee;
  text-align: center;
  color: #8c8c8c;
  float: left;
  font-size: 40px;
  vertical-align: middle;
}
#bigData .bigData-container .news-right .news-list time {
  font-size: 12px;
  /* color: #666; */
  white-space: nowrap;
}
#bigData .bigData-container .news-right .news-list .title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
#bigData .bigData-container .news-right .news-list p {
  color: #666;
  line-height: 1.8;
  text-align: justify;
  overflow: hidden;
}
#bigData .bigData-container .news h2:hover {
  color: #ff9600;
  text-decoration: underline;
}
#bigData .bigData-container .news-right .news-list h2:hover {
  color: #ff9600;
  text-decoration: underline;
}
#bigData .bigData-container .news p {
  font-size: 12px;
  color: #999;
  /* line-height: 2; */
  text-align: justify;
}
#bigData .new-clear {
  clear: both;
}
#bigData .new-tab {
  height: 30px;
  border-bottom: 2px dashed #eee;
  margin: 0 0 15px;
}
#bigData .new-tab span {
  font-size: 16px;
  cursor: pointer;
  padding: 1px;
  font-weight: 600;
  font-family: "仿宋", "微软雅黑";
}
.yellow-line {
  /* border-bottom: 2px solid #ff9600; */
  z-index: 99;
  color: #ff9600;
}
#bigData .new-tab .new-more {
  float: right;
  padding-right: 5px;
}
#bigData .new-tab span:hover {
  color: #ff9600;
}
#bigData .new-tab .new-more:hover {
  text-decoration: underline;
  color: #ff9600;
}
.about-more {
  display: block;
  margin: 22px auto;
  width: 158px;
  height: 42px;
  line-height: 42px;
  text-align: center;
  border: 1px solid #e6a23c;
  border-radius: 22px;
  color: #757575;
  font-size: 14px;
  cursor: pointer;
  outline: none;
  text-decoration: none;
  /* background: #e6a23c; */
  color: #e6a23c;
}
#bigData .bigData-title {
  padding-bottom: 40px;
  /* border-bottom: 1px solid #ccc; */
}
.ydPad {
  padding-left: 40px;
}
#bigData .more-detail {
  display: flex;
  justify-content: center;
  align-items: center;
}
#bigData .bigData-device {
  margin: 50px 0 20px;
}
.nav-item {
  padding-bottom: 100px;
}
.nav-item ul {
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
  margin: 0;
  padding: 0;
  list-style-type: none;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  align-items: center;
  /* padding-inline-start: 40px; */
}
.nav-item ul li {
  text-align: center;
  padding: 0 30px;
  font-size: 16px;
  list-style-type: none;
}
.nav-item ul li a {
  text-decoration: none;
  cursor: pointer;
  outline: none;
}
.nav-item ul li h6 {
  color: #5f5f5f;
  font-size: 18px;
  font-weight: bold;
  white-space: nowrap;
}
.nav-item ul .line {
  width: 1px;
  height: 28px;
  background-color: #dcdcdc;
}
.nav-item ul li p {
  color: #a5a5a5;
  font-size: 12px;
  text-transform: uppercase;
  white-space: nowrap;
}
/* 您身边的IT专家 */
#contactUs {
  color: #fff;
  height: 300px;
  background-size: 100% 100%;
  transition: all ease 0.6s;
}
#contactUs .contactUs-container {
  padding-top: 50px;
}
#contactUs .contactUs-container button {
  width: 300px;
  height: 50px;
  margin-top: 40px;
}
#contactUs .contactUs-container .contactUs-contactWay span {
  display: inline-block;
  width: 48px;
  height: 48px;
  margin: 30px;
}
#contactUs .contactUs-container .contactUs-contactWay span:nth-of-type(1) {
  background-size: 100% 100%;
}
#contactUs .contactUs-container .contactUs-contactWay span:nth-of-type(2) {
  background-size: 100% 100%;
}
#contactUs .contactUs-container .contactUs-contactWay span:nth-of-type(3) {
  background-size: 100% 100%;
}

/* 项目展示 */
#customer {
  padding: 100px 0px 0px 0px;
  box-sizing: border-box;
  background: #f1f1f1;
  transition: all ease 0.6s;
}
#customer .whyChooseUs-title {
  margin-bottom: 50px;
}
#customer .whyChooseUs-title p:nth-of-type(1) {
  font-size: 25px;
  font-weight: 500;
}
#customer .whyChooseUs-title p:nth-of-type(2) {
  font-size: 14px;
}
#customer .customer-title {
  font-size: 30px;
  /* color: #fff; */
  margin: 0 0 30px;
  font-weight: 600;
  letter-spacing: 4px;
}
#customer .customer-block {
  background: #f1f1f1;
  padding: 60px 30px;
  /* background: #337ab7; */
}
#customer .customer-logo img {
  width: 100%;
  height: 250px;
  border: 1px solid #ccc;
}
#customer .customer-yh img {
  width: 34px;
  height: 34px;
}
#customer .customer-content1 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  margin: 10px 10px 0px 10px;
}
#customer .customer-content1 small {
  font-weight: 600;
  font-size: 15px;
  cursor: pointer;
}
#customer .customer-content2 {
  padding-top: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  /* color: #656565 */
}
/* 为什么选择我们 */
#whyChooseUs {
  padding: 100px 0px 0px 0px;
}
#whyChooseUs .whyChooseUs-title {
  margin-bottom: 50px;
}
#whyChooseUs .whyChooseUs-title p:nth-of-type(1) {
  font-size: 25px;
  font-weight: 500;
}
#whyChooseUs .whyChooseUs-title p:nth-of-type(2) {
  font-size: 14px;
}
#whyChooseUs .server-block {
  /* padding: 50px 20px; */
  border: 1px solid #ccc;
  /* border-bottom: 5px solid #ccc; */
  overflow: hidden;
  cursor: pointer;
  /* box-shadow: 4px 4px 5px #aab8c3; */
}
#whyChooseUs .server-block:hover {
  box-shadow: 0px 0px 7px 0px #aab8c3;
  border: 1px solid rgb(123, 144, 201);
  border-bottom: 5px solid rgb(123, 144, 201);
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
}
#whyChooseUs .server-block .project-img {
  overflow: hidden;
}
#whyChooseUs .server-block img {
  width: 100%;
  height: 220px;
  transition: all 3s ease-out; /*ease-out 减速、慢慢结束*/
  -webkit-transition: all 3s ease-out;
}
#whyChooseUs .server-block:hover img {
  z-index: -995;
  transform: scale(1.1); /*把图片放大1.5倍*/
  -webkit-transform: scale(1.5);
}
#whyChooseUs .server-block > p {
  font-size: 14px;
  font-weight: 600;
  margin: 15px 0;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
#whyChooseUs .server-block > div {
  color: #ccc;
}
/* 媒体查询（手机） */
@media screen and (max-width: 767px) {
  #newPhone .firstNews .newImg {
    width: 100%;
    height: 160px;
  }
  /* #HomePage {
    padding-top: 60px;
  } */
  #swiper {
    height: 200px;
  }
  .showFlag {
    display: none;
  }
  #bigData .bigData-container .news-left {
    border-bottom: 1px solid #dcd5d5;
  }
  #bigData .bigData-container .news-right .news-list {
    border-bottom: 1px solid #dcd5d5;
  }
  #bigData {
    padding: 15px;
  }
  #bigData .bigData-title {
    font-size: 20px;
  }
  #bigData .bigData-device {
    font-size: 20px;
    margin: 10px 0 10px;
  }
  #contactUs {
    height: 200px;
    transition: all ease 0.6s;
  }
  #contactUs .contactUs-container {
    padding-top: 0;
  }
  #contactUs .contactUs-container h1 {
    font-size: 25px;
  }
  #contactUs .contactUs-container h3 {
    font-size: 18px;
  }
  #contactUs .contactUs-container button {
    width: 200px;
    height: 30px;
    margin-top: 20px;
  }
  #contactUs .contactUs-container .contactUs-contactWay span {
    display: inline-block;
    width: 28px;
    height: 28px;
    margin: 10px;
  }
  #customer {
    padding: 30px 0;
    box-sizing: border-box;
    background: #3b83c1eb;
  }
  #customer .about-more {
    display: block;
    margin: 50px auto;
    width: 158px;
    height: 42px;
    line-height: 42px;
    text-align: center;
    border: 1px solid #fff;
    border-radius: 22px;
    color: #fff;
    font-size: 14px;
    cursor: pointer;
    outline: none;
    text-decoration: none;
  }
  .nav-item ul {
    -webkit-justify-content: space-between;
    flex-wrap: wrap;
    -webkit-flex-wrap: wrap;
  }
  #customer .customer-title {
    font-size: 16px;
    font-weight: bold;
  }
  #customer .customer-logo img {
    width: 100%;
    height: 150px;
  }
  #customer .customer-block {
    padding: 30px;
  }
  #customer .customer-block > div {
    padding: 30px 0;
  }
  #whyChooseUs {
    padding: 20px 0;
    transition: all ease 0.6s;
  }
  #whyChooseUs .whyChooseUs-title p:nth-of-type(1) {
    font-size: 20px;
    font-weight: 700;
  }
  #whyChooseUs .whyChooseUs-title p:nth-of-type(2) {
    font-size: 12px;
  }
  #whyChooseUs .server-block {
    /* padding: 50px 0; */
    border: 1px solid #ccc;
    /* border-bottom: 5px solid #ccc; */
    overflow: hidden;
  }
  #whyChooseUs .server-block img {
    width: 100%;
    height: 150px;
  }
  #whyChooseUs .server-block > p {
    font-size: 14px;
    margin: 15px 0;
    display: -webkit-box;
    display: box;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 5;
  }
  #whyChooseUs .server-block > div {
    color: #ccc;
  }
  #bigData .bigData-container .news-right .news-list .nums {
    margin-right: 10px;
  }
  .ydPad,
  .newPad {
    padding: 0;
  }
  #bigData .bigData-container .news-right .news-list h2 {
    padding-right: 15px;
  }
  /* 手机新闻资讯 */
  #newPhone {
    /* background: #e7f1f7; */
    padding: 5px 0px 30px;
  }
  #newPhone .item-news {
    margin: 5px;
    padding: 12px 5px;
    background: #fff;
    border-bottom: 1px solid #eee;
  }
  #newPhone .item-news p {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    font-family: "微软雅黑";
  }
  #newPhone .item-news time {
    margin: 0;
    font-size: 12px;
    /* color: #b0b0b0; */
    line-height: 30px;
  }
  #newPhone .item-news img {
    width: 115px;
    height: 100px;
    border: 1px solid #eee;
  }
  #newPhone .item-news .news-detail {
    display: flex;
    /* padding: 10px 5px; */
  }
  #newPhone .item-news .news-detail .detail {
    font-size: 12px;
    color: #9e9a9a;
    padding: 0px 5px;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    /* height: 100px; */
    line-height: 25px;
    padding-left: 5px;
  }
  #newPhone .new-tab {
    /* height: 27px;
    text-align: center;
    margin: 0 0 15px; */
    border-bottom: 1px solid #eee;
    padding: 0 10px 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  #newPhone .new-tab .more-yd {
    font-size: 14px;
    color: #1989fa;
    margin: 0;
    font-family: "仿宋";
  }
  #newPhone .new-tab span {
    font-size: 16px;
    cursor: pointer;
    font-weight: 600;
    /* font-weight: 600; */
  }
  .yellow-line {
    /* border-bottom: 3px solid #ff9600; */
    z-index: 99;
    color: #ff9600;
  }
  #newPhone .new-tab .new-more {
    float: right;
    padding-right: 5px;
  }
  #newPhone .new-tab span:hover {
    color: #ff9600;
  }
  #newPhone .new-tab .new-more:hover {
    text-decoration: underline;
    color: #ff9600;
  }
}

/* 媒体查询（平板） */
@media screen and (min-width: 768px) and (max-width: 996px) {
  #swiper {
    height: 400px;
  }
  #bigData {
    /* padding: 60px; */
  }
  #bigData .bigData-title {
    font-size: 30px;
  }
  #bigData .bigData-device {
    font-size: 30px;
    margin: 30px 0 15px;
  }
  #contactUs {
    height: 400px;
  }
  #contactUs .contactUs-container {
    padding-top: 50px;
  }
  #contactUs .contactUs-container h1 {
    font-size: 30px;
  }
  #contactUs .contactUs-container h3 {
    font-size: 20px;
  }
  #contactUs .contactUs-container button {
    width: 300px;
    height: 50px;
    margin-top: 30px;
  }
  #contactUs .contactUs-container .contactUs-contactWay span {
    display: inline-block;
    width: 32px;
    height: 32px;
    margin: 15px;
  }
  #customer .customer-title {
    font-size: 24px;
  }
  #whyChooseUs {
    padding: 20px 0;
  }
}
.server-wrapper {
  padding: 5px 15px;
  height: 315px;
}
</style>




// WEBPACK FOOTER //
// src/view/HomePage.vue